export default __webpack_public_path__ + "static/media/pdfBarred.9120e32c.svg";